import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';
import { FiHome, FiUsers, FiPackage, FiCalendar, FiSettings, FiLogOut, FiMenu, FiX, FiClock, FiUser, FiDollarSign, FiBarChart2 } from 'react-icons/fi';

const adminNav = [
  { section: 'Overview' },
  { label: 'Dashboard', icon: FiHome, path: '/admin' },
  { section: 'Management' },
  { label: 'Shops', icon: FiUsers, path: '/admin/shops' },
  { label: 'Subscription Plans', icon: FiPackage, path: '/admin/plans' },
];

const shopNav = [
  { section: 'Overview' },
  { label: 'Dashboard', icon: FiHome, path: '/dashboard' },
  { section: 'Manage' },
  { label: 'Bookings', icon: FiCalendar, path: '/dashboard/bookings' },
  { label: 'Reports', icon: FiBarChart2, path: '/dashboard/reports' },
  { label: 'Services', icon: FiDollarSign, path: '/dashboard/services' },
  { label: 'Staff', icon: FiUsers, path: '/dashboard/staff' },
  { section: 'Settings' },
  { label: 'Working Hours', icon: FiClock, path: '/dashboard/hours' },
  { label: 'Shop Profile', icon: FiSettings, path: '/dashboard/profile' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  const brand = host.startsWith('parlour') ? 'parlour' : host.startsWith('dentist') ? 'dentist' : 'barber';
  const brandName = brand === 'parlour' ? 'ParlourHub' : brand === 'dentist' ? 'DentistHub19' : 'BarberHub';
  const brandIcon = brand === 'parlour' ? '💄' : brand === 'dentist' ? '🦷' : '✂️';
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = user?.role === 'admin' ? adminNav : shopNav;

  const handleLogout = () => {
    logout();
    toast.success('Logout ho gaye');
    navigate('/login');
  };

  const SidebarContent = () => (
    <div className={`sidebar ${mobileOpen ? 'open' : ''}`} style={{ width: '260px', position: 'fixed', height: '100vh', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
      <div className="sidebar-logo">
        <h2>{user?.role === 'admin' ? '🏢 Brainbox19' : `${brandIcon} ${brandName}`}</h2>
        <span>{user?.role === 'admin' ? '👑 Master Admin' : `${brandIcon} Shop Panel`}</span>
        <div style={{ marginTop: '8px', fontSize: '13px', color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>
          {user?.name || user?.shop_name}
        </div>
        {user?.role === 'shop' && user?.subscription_end && (
          <div style={{ marginTop: '4px', fontSize: '11px', color: 'var(--gold)' }}>
            📅 Expires: {new Date(user.subscription_end).toLocaleDateString('en-PK')}
          </div>
        )}
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item, i) => {
          if (item.section) return <div key={i} className="nav-section">{item.section}</div>;
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <Link key={i} to={item.path} className={`nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}>
              <Icon size={18} />
              {item.label}
            </Link>
          );
        })}

        {user?.role === 'shop' && (
          <a href={`/shop/${user?.slug}`} className="nav-item">
            <FiUser size={18} />
            My Shop Page ↗
          </a>
        )}
      </nav>

      <div style={{ padding: '20px', borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 'auto' }}>
        <button onClick={handleLogout} className="nav-item" style={{ width: '100%', background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', cursor: 'pointer' }}>
          <FiLogOut size={18} />
          Logout
        </button>
      </div>
    </div>
  );

  return (
    <>
      <style>{`
        @media (max-width: 768px) {
          .mobile-toggle { display: block !important; }
          .sidebar { transform: translateX(-100%); transition: transform 0.3s ease; z-index: 150; }
          .sidebar.open { transform: translateX(0); }
        }
        @media (min-width: 769px) {
          .mobile-toggle { display: none !important; }
        }
      `}</style>
      {/* Mobile toggle */}
      <button onClick={() => setMobileOpen(!mobileOpen)} style={{
        display: 'none', position: 'fixed', top: '16px', left: '16px', zIndex: 200,
        background: 'var(--primary)', color: 'white', border: 'none', borderRadius: '8px',
        padding: '8px', cursor: 'pointer'
      }} className="mobile-toggle">
        {mobileOpen ? <FiX size={20} /> : <FiMenu size={20} />}
      </button>

      <SidebarContent />
    </>
  );
}
